import React, { Component } from 'react';

//componentes
import SubirAcrchivos from './subirarchivos'

class Index extends Component {

    render(){
        return(
            <div>
                <SubirAcrchivos />
            </div>
        );
    }

}
export default Index;